import { OrdersState } from '../../models/account/orders.state';
import {
  CHANGE_PAGE,
  EXPAND_ORDER_ITEMS,
  FILTER_ORDERS_BY_DATE,
  FILTER_ORDERS_BY_DATE_SUCCESS,
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_ERROR,
  ActionsOrders,
  SORT_ORDERS_BY_PROPERTY,
  SORT_ORDERS_BY_PROPERTY_SUCCESS
} from '../../actions/account/actions-orders';
import { resetSortingOfOtherProperties } from '../../services/backend-account.service';
import { Sorting } from '../../models/account/sortingTypes.model';
import { TimePeriodsFilters } from '../../models/account/IOrderModel';

export const ordersInitState: OrdersState = {
  isLoading: true,
  currentPage: 1,
  pageSize: 4,
  totalPages: 0,
  sortingOrderNumber: Sorting.def,
  sortingDate: Sorting.asc,
  sortingStatus: Sorting.asc,
  timePeriodFilter: TimePeriodsFilters.lastSixMonths,
  officesFilter: 'ALL',
  orders: [],
  searchedOrders: []
};

/* eslint-disable */
export function reducersOrders(state = ordersInitState, action: ActionsOrders): OrdersState {
  switch (action.type) {
    case GET_ORDERS:
      return { ...state, isLoading: true };
    case GET_ORDERS_SUCCESS:
    case FILTER_ORDERS_BY_DATE_SUCCESS:
      state = { ...state, isLoading: false };
      state.searchedOrders = [];
      state.sortingOrderNumber = Sorting.asc;
      state.sortingDate = Sorting.def;
      state.sortingStatus = Sorting.def;
      state.timePeriodFilter = action.payload.timePeriod;
      state.officesFilter = action.payload.officesFilter;
      state.orders = action.payload.allOrders;
      state.searchedOrders = searchedOrders(state, action.payload.searchedOrders);
      state.currentPage = 1;
      state.totalPages = Math.ceil(action.payload.searchedOrders.length / state.pageSize);
      return state;
    case CHANGE_PAGE:
      state = { ...state };
      state.currentPage = action.payload;
      for (const value of state.searchedOrders) {
        value.shown = false;
        value.expanded = false;
      }

      for (
        let _i = state.currentPage * state.pageSize - state.pageSize;
        _i < state.currentPage * state.pageSize;
        _i++
      ) {
        if (_i < state.searchedOrders.length) {
          state.searchedOrders[_i].shown = true;
          state.searchedOrders[_i].expanded = _i === state.currentPage * state.pageSize - state.pageSize;
        }
      }
      return state;

    case SORT_ORDERS_BY_PROPERTY:
      const sortingProperty = action.payload.sortingProperty;
      const sortingDirection = action.payload.sorting;

      const sortedPropsForState = resetSortingOfOtherProperties(sortingProperty, sortingDirection);

      return {
        ...state,
        ...sortedPropsForState
      };
    case SORT_ORDERS_BY_PROPERTY_SUCCESS:
      state = { ...state };
      state.searchedOrders = action.payload;
      return state;
    case EXPAND_ORDER_ITEMS:
      state = { ...state };
      const opened = action.payload.opened;
      state.searchedOrders.forEach(function(o) {
        if (o.increment_id === action.payload.increment_id) {
          o.expanded = opened;
        }
      });
      return state;

    case FILTER_ORDERS_BY_DATE:
      state = { ...state };
      state.timePeriodFilter = action.payload;
      return state;

    case GET_ORDERS_ERROR:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}

function searchedOrders(state, searchedOrders) {
  state.searchedOrders = searchedOrders;
  for (let _i = 0; _i < state.searchedOrders.length; _i++) {
    state.searchedOrders[_i].shown = false;
    state.searchedOrders[_i].expanded = _i === 0;
  }
  for (let _i = state.currentPage * state.pageSize - state.pageSize; _i < state.currentPage * state.pageSize; _i++) {
    if (_i < state.searchedOrders.length) {
      state.searchedOrders[_i].shown = true;
    }
  }
  return state.searchedOrders;
}
